<template>
  <div class="main">
    <div class="title">无忧退票险</div>
    <el-divider id="bottom-divider"></el-divider>
    <table border="1" cellspacing="0" cellpadding="0">
      <tr class="tr1" style="height: 30px ">
        <th style="width: 160px">产品名称</th>
        <th style="width: 160px">承保公司</th>
        <th style="width: 240px">保障范围</th>
        <th style="width: 240px">赔偿限额</th>
        <th style="width: 160px">保险期限</th>
      </tr>
      <tr>
        <td>无忧退票险</td>
        <td>宇宙永不破产保险股份有限公司</td>
        <td>
          客户预订并支付机票价款之后无法按期登机而退票，对于不能退回的机票价款损失，赔偿机票退票损失的65%
        </td>
        <td>最高赔付1500元</td>
        <td>约定航班</td>
      </tr>
      <tr style="height: 50px">
        <td colspan="5">无忧退票险保险费：30元/份.航班</td>
      </tr>
    </table>
  </div>
</template>
<style lang="scss" scoped>
@import '@/assets/css/config.scss';
.title {
  margin-top: 10%;
  line-height: 30px;
  font-weight: 600;
  font-size: 20px;
  color: $themeLight;
}
#bottom-divider {
  margin-top: 30px;
  height: 0.07px;
  line-height: 0.07px;
}
table {
  border-color: $themeLightGray;
  font-size: 14px;
}
tr {
  line-height: 35px;
}
td {
  padding: 10px 4px;
  font-size: 12px;
}
</style>
